import React, { useState } from 'react';
import { useSocketContext } from '../../context/SocketContext';
import { fetchSyncDetails } from '../../api/syncApi';
import { toast } from 'react-toastify';
import HistoryTable from '../logs/HistoryTable';
import LiveMonitor from '../logs/LiveMonitor';
import TerminalViewer from '../logs/TerminalViewer';
import SyncDetailsModal from '../logs/SyncDetailsModal';
import '../../styles/logs.css';
import '../../styles/schedule.css';

const TABS = [
  { id: 'history',  label: 'History',      icon: 'bi-clock-history' },
  { id: 'live',     label: 'Live Monitor', icon: 'bi-activity'      },
  { id: 'terminal', label: 'Terminal',     icon: 'bi-terminal'      },
];

const LogsPage = () => {
  const [activeTab, setActiveTab] = useState('history');
  const [selectedSync, setSelectedSync] = useState(null);
  const [loadingDetailsId, setLoadingDetailsId] = useState(null);

  const { runningSyncs = [], syncHistory = [], isConnected = false } = useSocketContext();

  // Called when a delete action changes history so the parent context can re-fetch
  const handleHistoryChanged = () => {
    // SocketContext refreshes automatically via WebSocket events;
    // nothing to do here unless the app provides a manual refresh callback.
  };

  const handleViewDetails = async (syncId) => {
    setLoadingDetailsId(syncId);
    try {
      const details = await fetchSyncDetails(syncId);
      setSelectedSync(details);
    } catch {
      toast.error('Failed to load sync details');
    } finally {
      setLoadingDetailsId(null);
    }
  };

  return (
    <div className="logs-page">
      {/* Page header */}
      <div className="logs-page-header">
        <div>
          <h1 className="logs-page-title">Logs</h1>
          <p className="logs-page-subtitle">
            Sync history, live monitor, and terminal output
          </p>
        </div>

        {/* Sub-tab nav */}
        <nav className="logs-tab-nav" aria-label="Logs sub-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`logs-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
              aria-current={activeTab === tab.id ? 'page' : undefined}
            >
              <i className={`bi ${tab.icon}`}></i>
              {tab.label}
              {tab.id === 'live' && runningSyncs.length > 0 && (
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    background: 'var(--accent-green)',
                    color: '#fff',
                    lineHeight: 1,
                  }}
                >
                  {runningSyncs.length}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab content */}
      {activeTab === 'history' && (
        <HistoryTable
          history={syncHistory}
          onViewDetails={handleViewDetails}
          loadingDetailsId={loadingDetailsId}
          onHistoryChanged={handleHistoryChanged}
        />
      )}

      {activeTab === 'live' && (
        <LiveMonitor
          runningSyncs={runningSyncs}
          isConnected={isConnected}
        />
      )}

      {activeTab === 'terminal' && (
        <TerminalViewer syncHistory={syncHistory} />
      )}

      {/* Sync Details Modal */}
      {selectedSync && (
        <SyncDetailsModal
          sync={selectedSync}
          onClose={() => setSelectedSync(null)}
        />
      )}
    </div>
  );
};

export default LogsPage;
